import {useStore} from "vuex";
import {computed} from "vue";

const useTrafficStore = () => {
  const store = useStore();

  const range = computed(() => store.getters['traffic/range']);
  const compareRange = computed(() => store.getters['traffic/compareRange']);
  const fromDate = computed(() => store.getters['traffic/fromDate']);
  const toDate = computed(() => store.getters['traffic/toDate']);
  const compareFromDate = computed(() => store.getters['traffic/compareFromDate']);
  const compareToDate = computed(() => store.getters['traffic/compareToDate']);
  const compare = computed(() => store.getters['traffic/compare']);

  return {
    range,
    compareRange,
    fromDate,
    toDate,
    compare,
    compareFromDate,
    compareToDate,
  };
};

export default useTrafficStore;